import { pathOr, propOr } from 'ramda';
import { handleActions } from 'redux-actions';
import {
  INIT,
  TRACK_LOAD_CUSTOM_OPTIONS,
  TRACK_START,
  TRACK_QUARTER,
  TRACK_HALF,
  TRACK_THREE_QUARTERS,
  TRACK_END,
} from '../../actions/types';

export const INITIAL_STATE = {
  nextMilestone: 0,
  contentId: '9.999',
  source: 'Podcast Player',
};

export const reducer = handleActions(
  {
    [INIT]: (_, { payload }) => ({
      ...INITIAL_STATE,
      contentId: pathOr('9.999', ['customOptions', 'articleId'], payload),
    }),
    [TRACK_LOAD_CUSTOM_OPTIONS]: (state, { payload }) => ({
      ...state,
      source: propOr('PodcastPlayer', 'customSource', payload),
    }),
    [TRACK_START]: state => ({
      ...state,
      nextMilestone: 25,
    }),
    [TRACK_QUARTER]: state => ({
      ...state,
      nextMilestone: 50,
    }),
    [TRACK_HALF]: state => ({
      ...state,
      nextMilestone: 75,
    }),
    [TRACK_THREE_QUARTERS]: state => ({
      ...state,
      nextMilestone: 100,
    }),
    [TRACK_END]: state => ({
      ...state,
      nextMilestone: 125, // unreachable
    }),
  },
  INITIAL_STATE,
);
